module.exports = __webpack_public_path__ + "static/img/7173f41da603e8d24a419ac02c64b529.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon4.jpg
// module id = PFBd
// module chunks = 1